import { useLayoutEffect } from 'react';
import { ExamenesLabProvider, useExamenesLabCtx } from './ExamenesLabContext';
import FormView from './views/FormView';
import {
	ConsultaConTuMedicoModal,
	FormResponseModal,
	ResultadoModal,
} from './views/Modals';
import TusResultados from './views/TusResultados';
import Results from './views/Results';

function Content() {
	const { view } = useExamenesLabCtx();

	useLayoutEffect(() => {
		document.documentElement.scrollTo(0, 0);
	}, [view]);

	switch (view) {
		case 'form':
			return <FormView />;
		case 'response':
			return <Results />;
		case 'results':
			return <TusResultados />;
		default:
			return null;
	}
}

export default function ExamenesLaboratorio() {
	return (
		<ExamenesLabProvider>
			<Content />
			<ResultadoModal />
			<ConsultaConTuMedicoModal />
			<FormResponseModal />
		</ExamenesLabProvider>
	);
}
